import {TranslationServiceInterface} from "../../../../translation-service.interface";
import {CustomGroup} from "../../../../../domain/in/quote/group/custom-group";
import {EmployeeRoleEnum} from "../../../../../domain/enum/employee-role.enum";
import {CustomGroupSummary} from "../../../../../domain/out/custom-group-summary";
import {getAmountWithCurrency} from "../../../../../utils/string-utils";
import {getWeeklyAndMonthlyAmount} from "../../../../../utils/math-utils";
import {CustomGroupSummaryMapper} from "../../custom-group-summary.mapper";
import {TableSummaryCaIcsHbeMapper} from "./table-summary-ca-ics-hbe.mapper";
import {OrderedSynthesisService} from "../../ordered-synthesis.service";
import {EnumDisplayMode} from "../../../../../domain/in/quote/enum-display-mode";

export class FrCaIcsHbeCustomGroupSummaryMapper implements CustomGroupSummaryMapper {
    private tableSummaryCaIcsHbeMapper: TableSummaryCaIcsHbeMapper;

    constructor(protected translationService: TranslationServiceInterface) {
        this.tableSummaryCaIcsHbeMapper = new TableSummaryCaIcsHbeMapper(translationService);
    }

    public async getCustomGroupSummary(customGroups: CustomGroup[], role: EmployeeRoleEnum, serviceCode: string, currency: string, view: string, locale: string, displayMode?: EnumDisplayMode): Promise<CustomGroupSummary[]> {
        return await Promise.all(OrderedSynthesisService.sortCustomGroups(customGroups,serviceCode).map(async group => {
            const {weekly, monthly} = getWeeklyAndMonthlyAmount(group.totalAppliedPrice, displayMode);
            return new CustomGroupSummary(
                group.title,
                group.order,
                await this.tableSummaryCaIcsHbeMapper.getTablesSummary(group, serviceCode, currency, view, locale),
                getAmountWithCurrency(group.totalAppliedPrice, currency, locale),
                getAmountWithCurrency(weekly, currency, locale),
                getAmountWithCurrency(monthly, currency, locale)
            );
        }));
    }

}
